module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgrid),
      expression: "showgrid"
    }]
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "ng-show": "$ctrl.isNewAvaiable()"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "tooltip": "Adiciona um público alvo",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showgrid = !_vm.showgrid
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova Meta")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table b-table table-hover table-bordered b-table-stacked-md",
    attrs: {
      "role": "table",
      "aria-busy": "false",
      "aria-colcount": "7",
      "aria-rowcount": "-1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_vm._l((_vm.propsObjetivos), function(objetivo, objetivoIndex) {
    return _vm._l((objetivo.goals), function(meta, metaIndex) {
      return _c('tr', {
        attrs: {
          "role": "row"
        }
      }, [_c('td', {
        staticClass: "text-center",
        attrs: {
          "aria-colindex": "1",
          "data-label": "Objetivo",
          "role": "cell"
        }
      }, [_c('div', [_vm._v("\n                    " + _vm._s(objetivo.description) + "\n                  ")])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "aria-colindex": "2",
          "data-label": "Meta do Projeto",
          "role": "cell"
        }
      }, [_c('div', [_vm._v("\n                    " + _vm._s(meta.description) + "\n                  ")])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "aria-colindex": "3",
          "data-label": "Meta Orçada",
          "role": "cell"
        }
      }, [_c('div', [_vm._v("\n                    " + _vm._s(meta.quantity) + "\n                  ")])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "aria-colindex": "4",
          "data-label": "Meta Orçada",
          "role": "cell"
        }
      }, [_c('div', [_vm._v("\n                    " + _vm._s(meta.measurementUnit) + "\n                  ")])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "aria-colindex": "5",
          "data-label": "Meta Orçada",
          "role": "cell"
        }
      }, [_c('div', [_vm._v("\n                    " + _vm._s(meta.duration) + "\n                  ")])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "aria-colindex": "6",
          "data-label": "Meta Orçada",
          "role": "cell"
        }
      }, [_c('div', [_vm._v("\n                    " + _vm._s(meta.performanceIndicators) + "\n                  ")])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "aria-colindex": "6",
          "data-label": "Meta Orçada",
          "role": "cell"
        }
      }, [_c('div', [_c('button', {
        staticClass: "btn btn-primary btn-sm btn-flat",
        attrs: {
          "type": "button",
          "disabled": false
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.edita(objetivoIndex, meta)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil-square-o",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Editar")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-danger btn-sm btn-flat",
        attrs: {
          "type": "button",
          "disabled": false
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.exclui(objetivo, metaIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Excluir")])])])])
    })
  })], 2)])])])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('objetivo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "objective"
    }
  }, [_vm._v("Objetivo Específico:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addGoalCtrl.approval",
      "state": "addGoalCtrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.objetivoIndex),
      expression: "objetivoIndex"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "objetivo",
      "ng-options": "objective.description for objective in proposta.specificObjectives"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.objetivoIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.propsObjetivos), function(objetivo, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(objetivo.description))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('objetivo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('O que')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("O que? ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addGoalCtrl.approval",
      "state": "addGoalCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meta.description),
      expression: "meta.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "O que",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.meta.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.meta, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('O que')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('O que')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('quantidade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("Quanto?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addGoalCtrl.approval",
      "state": "addGoalCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meta.quantity),
      expression: "meta.quantity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "quantidade",
      "type": "number",
      "min": "1",
      "max": "2147483647"
    },
    domProps: {
      "value": (_vm.meta.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.meta, "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('unidade de medida')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "measurementUnit"
    }
  }, [_vm._v("Unidade de medida:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addGoalCtrl.approval",
      "state": "addGoalCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meta.measurementUnit),
      expression: "meta.measurementUnit"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "unidade de medida",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.meta.measurementUnit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.meta, "measurementUnit", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('unidade de medida')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('unidade de medida')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Quanto tempo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Quanto tempo?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addGoalCtrl.approval",
      "state": "addGoalCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meta.duration),
      expression: "meta.duration"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "Quanto tempo",
      "type": "number",
      "min": "1",
      "max": "2147483647"
    },
    domProps: {
      "value": (_vm.meta.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.meta, "duration", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Quanto tempo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Quanto tempo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Indicadores de execução')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "performanceIndicators"
    }
  }, [_vm._v("Indicadores de execução:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addGoalCtrl.approval",
      "state": "addGoalCtrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meta.performanceIndicators),
      expression: "meta.performanceIndicators"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Indicadores de execução",
      "ng-options": "indicator for indicator in listIndicators"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.meta, "performanceIndicators", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listIndicators), function(indicador, index) {
    return _c('option', {
      domProps: {
        "value": indicador
      }
    }, [_vm._v(_vm._s(indicador))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('Indicadores de execução')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Indicadores de execução')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-goal-add"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-goal-cancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {}, [_c('tr', [_c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "1"
    }
  }, [_vm._v("Objetivo")]), _vm._v(" "), _c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "2"
    }
  }, [_vm._v("Meta do Projeto")]), _vm._v(" "), _c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "3"
    }
  }, [_vm._v("Meta Orçada")]), _vm._v(" "), _c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "4"
    }
  }, [_vm._v("Unidade de medida")]), _vm._v(" "), _c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "5"
    }
  }, [_vm._v("Duração")]), _vm._v(" "), _c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "6"
    }
  }, [_vm._v("Indicador")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center",
      "width": "13%"
    },
    attrs: {
      "aria-colindex": "7"
    }
  }, [_vm._v("Ações")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69918164!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/metasOld.vue
// module id = 1997
// module chunks = 1